import React from 'react';

/**
 * Return `value` when truthy, otherwise the most recent truthy value seen so far.
 * Useful for streaming UIs where the source momentarily emits a falsy/empty value
 * during partial updates and we want to avoid flicker.
 */
export const useStableLastTruthy = <T>(value: T): T => {
  const ref = React.useRef(value);
  React.useEffect(() => {
    if (value) {
      ref.current = value;
    }
  }, [value]);
  return value || ref.current;
};
